import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const ProductIntro: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product) return null;

  const { productName, productDescription, productTaglines, headingColor, textColor,headingFontStyle, fontStyle } = context.product;

  return (
    <div className="w-full max-w-2xl mx-auto px-4 py-5 font-mulish text-left">
      <h2
        style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
        className="text-base font-bold leading-tight pb-2"
      >
        {productName}
      </h2>
      <p style={{color: textColor, fontFamily: fontStyle}} className="text-sm mt-1 leading-snug">
        {productDescription}
      </p>
      <div className="pt-4 text-center">
        {productTaglines && productTaglines.some((tagline) => tagline.trim() !== "") && (
          <p
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000" }}
            className="text-gray-900 font-bold italic text-base"
          >
            "{productTaglines}"
          </p>
        )}
      </div>
    </div>
  );
};

export default ProductIntro;
